const data = {
  id: null,
  isFirstJob: 1,
  firstJobDate: null,
  firstJobDateStr: null,
  hasSeparationProve: null,
  hasProveBeforeDatatime: null,
  separationProveUrl: null,
  separationProveId: null,
  separationProveName: null,
  hasDismissLaborRelation: null,
  hasDismissLaborRelationV: null,
  hasLaborRelation: null,
  hasCompetitionAgreement: null,
  hasCompetitionAgreementV: null,
  competitionAgreeCompany: null,
  competitionAgreeStartDate: null,
  competitionAgreeStartDateStr: null,
  competitionAgreeEndDate: null,
  competitionAgreeEndDateStr: null,
  jobOffMonth: 0,
  works: [],
  outOfWorks: [],
  company: null,
  startDate: null,
  endDate: null,
  position: null,
  rank: null,
  leaveReason: null,
  witnessName: null,
  witnessPosition: null,
  witnessPhone: null,
};

export default data;
